<script lang="ts" generics="Invalids extends Record<string, ValidityState>">
  import InvalidHoverInfo from './InvalidHoverInfo.svelte'
  import InvalidIcon from './InvalidIcon.svelte'
  import { NOT_URL_PATTERN, ValidityState } from '@utils/validation.svelte'

  interface Props {
    prefix: string
    invalids: Invalids
    fieldName: keyof Props['invalids'] & string
    fieldValue: string | null
    setField: (newValue: string) => void
    required?: boolean
    disabled?: boolean
  }
  const {
    prefix,
    invalids,
    fieldName,
    fieldValue,
    setField,
    required = true,
    disabled = false,
  }: Props = $props()

  const pasteHandler =
    (prefix: string, setField: (value: string) => void) =>
    (e: ClipboardEvent & { currentTarget: HTMLInputElement }) => {
      const selection = window.getSelection()
      if (selection?.toString() == e.currentTarget.value && e.clipboardData) {
        e.currentTarget.value = decodeURI(e.clipboardData.getData('text/plain').replace(prefix, ''))
        setField(encodeURI(prefix + e.currentTarget.value))
        e.preventDefault()
      }
    }
  const copyHandler =
    (prefix: string) => (e: ClipboardEvent & { currentTarget: HTMLInputElement }) => {
      const selection = window.getSelection()
      if (selection?.type !== 'Range' || selection?.toString() == e.currentTarget.value) {
        e.clipboardData?.clearData()
        e.clipboardData?.setData('text/plain', prefix + encodeURI(e.currentTarget.value))
        e.preventDefault()
      }
    }
</script>

<div
  class={`input input-group input-group-divider ${
    required ? 'grid-cols-[auto_1fr_auto]' : 'grid-cols-[auto_1fr]'
  } [&>.input-group-shim]:!min-w-8 [&>.input-group-shim]:max-md:block`}
>
  <div
    class="input-group-shim max-md:max-w-40 max-md:overflow-hidden max-md:text-ellipsis max-md:whitespace-nowrap max-md:leading-8"
  >
    {prefix}
  </div>
  <input
    class="my-0 box-border flex px-2 py-1 md:min-w-96"
    type="text"
    id={fieldName}
    value={decodeURI(fieldValue?.replace(prefix, '') ?? '')}
    pattern={NOT_URL_PATTERN}
    onchange={(e) => {
      setField(encodeURI(prefix + e.currentTarget.value))
    }}
    onpaste={pasteHandler(prefix, setField)}
    oncopy={copyHandler(prefix)}
    {required}
    {disabled}
  />
  {#if required}
    <InvalidIcon {invalids} field={fieldName} value={fieldValue} />
  {/if}
</div>
<InvalidHoverInfo {invalids} field={fieldName} />
